import axios from "axios";
const baseUrl = process.env.NODE_ENV === 'development' ? `http://localhost:8082` : 'https://backend.manager.catalog.picar.cloud'
const instance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});
export default instance;